import Axios from '@/common/require'
export default{
  GET_SUBSCRIPT_LIST(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/subscription/index',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  SET_EMAIL(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/subscription/set',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  DEL_SUBSCRIPT(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/subscription/del',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/subscript/actions.js